<template>
  <!-- Kontener główny widoku z dwoma sekcjami: filtrami i główną treścią -->
  <div class="content-container">
    <!-- Komponent filtrów do wyszukiwania archiwalnych pomiarów (np. wybór dat, lokalizacji) -->
    <filters-archival-measurements />
    <div class="content-wrap">
      <!-- Pasek menu u góry strony -->
      <TopMenu />
      <!-- Główna zawartość – komponent z listą tablic czarnych (BlackList) -->
      <BlackList />
    </div>
  </div>
</template>

<script>
// Import komponentów używanych w tym widoku
import TopMenu from "../components/TopMenu.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import BlackList from "../components/BlackList.vue";

export default {
  name: "BlackListView", // Nazwa widoku (przydatna np. przy debugowaniu)
  components: {
    TopMenu,
    BlackList,
    FiltersArchivalMeasurements,
  },
  methods: {
    // Metoda pomocnicza do czyszczenia stanu filtrów/widoku – nieużywana bezpośrednio tutaj, ale gotowa na przyszłość
    clear() {
      this.archival.clear();
      this.step = this.archival.step;
      this.isResult = this.archival.isResult;
    },
  },
};
</script>

<style scoped>
/* Ustawienie tła całego kontenera na jasny kolor */
.content-container {
  background-color: #f5f4f2;
}
</style>
